import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';

@Component({})
export default class OCTtlMain extends Mixins(BASEComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public color!: string;
}
